<template>
  <nav class="sidebar">
    <div class="sidebar-box">
      <p class="box-title">Modele</p>
      <div v-if="selected.car_brand != ''">
        <div class="block-grid">
          <button
            v-if="show_more_models"
            class="block-button"
            v-for="car_model in car_models"
            @click="
              () => {
                selected.car_model = car_model;
                this.$parent.getOffers();
              }
            "
            :class="{ active: selected.car_model == car_model }"
          >
            {{ car_model }}
          </button>
          <button
            v-else
            class="block-button"
            v-for="car_model in car_models.slice(0, 5)"
            @click="
              () => {
                selected.car_model = car_model;
                this.$parent.getOffers();
              }
            "
            :class="{ active: selected.car_model == car_model }"
          >
            {{ car_model }}
          </button>
        </div>
        <span
          class="show_more"
          @click="show_more_models = false"
          v-if="show_more_models"
          >Hide</span
        >
        <span class="show_more" @click="show_more_models = true" v-else
          >Show More</span
        >
      </div>
      <span v-else> Marka samochodu nie została wybrana </span>
    </div>
    <div class="sidebar-box">
      <p class="box-title">Rocznik</p>
      <div class="dropdown-box">
        <div class="select_box">
          <multiselect
            class="dropdown"
            v-model="selected.year_from"
            :options="
              Array.from(
                { length: 2024 - 2000 + 1 },
                (_, index) => 2000 + index
              ).reverse()
            "
            value="2020"
            :searchable="true"
            :show-labels="false"
            placeholder="Rocznik od"
            @select="this.$parent.getOffers"
          ></multiselect>
        </div>
        <span>-</span>
        <div class="select_box">
          <multiselect
            class="dropdown"
            v-model="selected.year_to"
            :options="
              Array.from(
                { length: 2024 - 2000 + 1 },
                (_, index) => 2000 + index
              ).reverse()
            "
            :searchable="true"
            :show-labels="false"
            placeholder="Rocznik do"
            @select="this.$parent.getOffers"
          ></multiselect>
        </div>
      </div>
    </div>
    <div class="sidebar-box">
      <p class="box-title">Prognozowany koszt</p>
      <div class="dropdown-box">
        <div class="select_box">
          <input
            type="number"
            class="input"
            v-model="selected.estimated_retail_value_from"
          />
        </div>
        <span>-</span>
        <div class="select_box">
          <input
            type="number"
            class="input"
            v-model="selected.estimated_retail_value_to"
          />
        </div>
        <span class="dollar-sign">$</span>
      </div>
    </div>

    <div class="sidebar-box">
      <p class="box-title">Dom Aukcyjny</p>
      <div class="block-grid">
        <button
          class="block-button"
          @click="
            () => {
              selected.auction_name = null;
              this.$parent.getOffers();
            }
          "
          :class="{ active: selected.auction_name == null }"
        >
          WSZYSTKIE
        </button>
        <button
          class="block-button"
          @click="
            () => {
              selected.auction_name = 'iaai';
              this.$parent.getOffers();
            }
          "
          :class="{ active: selected.auction_name == 'iaai' }"
        >
          IAAI
        </button>
        <button
          class="block-button"
          @click="
            () => {
              selected.auction_name = 'copart';
              this.$parent.getOffers();
            }
          "
          :class="{ active: selected.auction_name == 'copart' }"
        >
          COPART
        </button>
      </div>
    </div>
    <div class="sidebar-box">
      <p class="box-title">Przebieg</p>
      <div class="dropdown-box">
        <div class="select_box">
          <input
            type="number"
            class="input"
            v-model="selected.odometer_from"
            @change="this.$parent.getOffers"
          />
        </div>
        <span>-</span>
        <div class="select_box">
          <input
            type="number"
            class="input"
            v-model="selected.odometer_to"
            @change="this.$parent.getOffers"
          />
        </div>
        <span class="dollar-sign"></span>
      </div>
    </div>
    <!-- <div class="sidebar-box">
      <p class="box-title">Status</p>
      <div class="block-grid">
        <button class="block-button">WSZYSTKIE</button>
        <button class="block-button">ODPALA I RUSZA</button>
        <button class="block-button active">ODPALA</button>
        <button class="block-button">NIE ODPALA</button>
      </div>
    </div> -->
    <!-- <div class="sidebar-box">
      <p class="box-title">Skrzynia biegów</p>
      <div class="block-grid">
        <button class="block-button">WSZYSTKIE</button>
        <button class="block-button">MANUALNA</button>
        <button class="block-button active">AUTOMATYCZNA</button>
      </div>
    </div> -->
    <!-- <div class="sidebar-box">
      <button class="search-button" @click="this.$parent.getOffers">
        Szukaj
      </button>
    </div> -->
  </nav>
</template>





<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  name: "Sidebar",
  props: ["selected"],
  data() {
    return {
      car_models: [],
      selected: this.$parent.selected,
      show_advanced: false,
      show_more_models: false,
    };
  },
  beforeMount() {
    if (this.selected.car_brand != null) {
      this.getMakes();
    }
  },
  methods: {
    async getMakes() {
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-model-by-make-name",
        {
          make: this.selected.car_brand,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      var models = [];
      for (var i in data) {
        if (data[i]["model"] != "") {
          models.push(data[i]["model"]);
        }
      }
      this.car_models = models;
    },
  },
  components: {
    Multiselect,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
nav {
  width: 500px;
  display: flex;
  flex-direction: column;
}
.sidebar-box {
  margin-bottom: 20px;
  padding: 25px;
  padding-top: 12px;
  background-color: rgb(255, 255, 255);
  height: 100%;
}
.dropdown {
  display: block;
  width: 118px;
}

.dropdown-box {
  display: flex;
  justify-content: space-between;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
}

.box-title {
  font-weight: bold;
  color: #011f68;
  font-size: 17px;
}
.input {
  position: relative;
  display: inline-block;
  font-family: "Bicyclette", Helvetica, Arial, sans-serif;
  border-style: solid;
  border-radius: 5px;
  background: #fff;
  padding: 10px 8px;
  width: 118px;
  font-size: 14px;
  color: #39495d;
  transition: border 0.1s ease;
  box-sizing: border-box;
  vertical-align: top;
  border-color: lightgray;

  border-width: 1px;
}
.search-button {
  background-color: #be1e2d;
  border: none;
  box-sizing: border-box;
  color: #ffffff;
  font-size: 16px;
  padding: 6px 16px;
  position: relative;
  transition: background-color 0.2s cubic-bezier(0.3, 0, 0.5, 1);
  user-select: none;
  -webkit-user-select: none;
  white-space: nowrap;
  word-wrap: break-word;
  /* max-width: 400px; */
  width: 100%;
  display: block;
  height: 40px;
  margin-top: 20px;
  border-radius: 4px;
  margin-bottom: 10px;
}
.search-button:hover {
  border: 1px solid rgba(27, 31, 35, 0.15);
  border-radius: 6px;
  background-color: #833b42;
  text-decoration: none;
  transition-duration: 0.1s;
  color: white;
}
.block-button {
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  background-color: #edf2f7;
  color: #011f68;
  font-weight: bold;
  font-size: 12px;
  border-radius: 2px;
  margin-right: 7px;
  margin-bottom: 7px;
}
.block-button.active {
  color: white;
  background-color: #011f68;
}
.dollar-sign {
  margin-top: 7px;
  font-size: 20px;
  color: #011f68;
}
label {
  color: #011f68;
  font-family: "bicyclette";
  font-size: 16px;
  font-weight: 700;
  line-height: 20.8px;
  margin-bottom: 10px;
  display: block;
}

.year {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 240px;
  align-items: center;
}
.year .select_box {
  max-width: 100px;
}
.year .input {
  max-width: 90px;
}
.show_more {
  font-size: 13px;
}
</style>







